<p-dialog [(visible)]="visibleModalQRProcess" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="subtitle mb-15">
          <h2>Por favor realiza los siguientes pasos:</h2>
        </div>
        <div class="stepBox">
          <div class="text smallList">
            <ng-container *ngIf="isManual" >
              <ul>
                <li>
                  <div class="stepNumber"><span>1</span></div>
                  <p>Enciende el dispositivo e inicialo hasta la pantalla principal sin conectar a Wi-Fi.</p>
                </li>
                <li>
                  <div class="stepNumber"><span>2</span></div>
                  <p>En la pantalla inicial, ahora sí conecta el equipo a una red Wi-Fi estable.</p>
                </li>
                <li>
                  <div class="stepNumber"><span>3</span></div>
                  <p>Abre la cámara de Google Chrome y escanea el código QR desde el portal de ventas.</p>
                </li>
                <li>
                  <div class="stepNumber"><span>4</span></div>
                  <p>En Google Chrome, permite la instalación desde esta fuente y descarga la app.</p>
                </li>
                <li>
                  <div class="stepNumber"><span>5</span></div>
                  <p>Abre la app "Device Pro" y selecciona COMENZAR.</p>
                </li>
                <li>
                  <div class="stepNumber"><span>6</span></div>
                  <p>Activa las opciones solicitadas (HABILITAR) y ajusta el apagado automático al mayor tiempo posible.</p>
                </li>
                <li>
                  <div class="stepNumber"><span>7</span></div>
                  <p>Ingresa a "Versión del dispositivo" y toca 7 veces el número de versión para activar el Modo Desarrollador.</p>
                </li>
                <li>
                  <div class="stepNumber"><span>8</span></div>
                  <p>Activa la depuración inalámbrica y acepta los permisos.</p>
                </li>
                <li>
                  <div class="stepNumber"><span>9</span></div>
                  <p>Ingresa el código de emparejamiento (Código de emparejamiento) y espera que el equipo se conecte automáticamente.</p>
                </li>
                <li>
                  <div class="stepNumber"><span>10</span></div>
                  <p>Acepta los términos finales; la app DevicePro se eliminará automáticamente al completar el enrolamiento.</p>
                </li>
              </ul>
              <div class="dialog__info mt-15">
                <h2>Usar el nuevo enrolamiento con el teléfono iniciado</h2>
              </div>
            </ng-container>
            <ng-container *ngIf="!isManual">
              <ul>
                <li>
                  <div class="stepNumber"><span>1</span></div>
                  <p>Enciende el teléfono nuevo.</p>
                </li>
                <li>
                  <div class="stepNumber"><span>2</span></div>
                  <p>Sigue las instrucciones para configurar el teléfono que se muestran en la pantalla.</p>
                </li>
                <li>
                  <div class="stepNumber"><span>3</span></div>
                  <p>Asegúrate que estás conectado a una Wifi con acceso a internet.</p>
                </li>
              </ul>
              <div class="dialog__info mt-15">
                <h2>Usar el enrolamiento antiguo dando 7 toques en la pantalla </h2>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="dialog__text miniPad">
          <div class="qr-code">
            <div class="qr-code__img big">
              <qrcode [qrdata]="qrCode" [width]="500" [errorCorrectionLevel]="'M'"></qrcode>
            </div>
          </div>
        </div>
        <div class="dialog__btn dialog__block">
          <button pButton pRipple label="Continuar el proceso" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="visibleModalEndProcess=true; visibleModalQRProcess=false"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<p-dialog [(visible)]="visibleModalEndProcess" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>¿Realizaste todo el proceso completo?</h2>
          <p>Puedes volver al paso anterior si crees que no estás listo.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Si, realicé todo el proceso" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onProgressEnrollment()"></button>
          <div class="dialog__btnFloat">
            <p-button label="Volver al paso anterior" icon="pi pi-arrow-left" iconPos="left" [text]="true" [plain]="true" (onClick)="onReturnEnrollment()"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
